export function parseIds(value) {
  if (Array.isArray(value)) {
    return value.map(Number).filter(Boolean);
  }
  if (value == null || value === '') {
    return [];
  }
  return String(value).split(',').map(Number).filter(Boolean);
}

export function pageSlice(list, page, pageSize) {
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}
